
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0HJAHScveEUOPF4hjqeIbEOiA_456jECGmREFaU_457ETmcMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index2OS6_45LsrBHnpEWg3yzxUFHaLw_45w8aw7YBRQvECqzKGcMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchIpXkiNiEJv_45TaU0S3QenRQ8dlIkh3LGDoVCgdtVdG9QMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexavYpktEYa8aYle0kaeWcV2KeR24Q_45I0PqdRsNRl2qTYMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93prlJW56gtqpkzQoKbXBgrsZhsPqScIGUciQ0LAwuo9cMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGAt5MaoUjUC4InjEy2QgC5TTXeED9kUFEjx6yKCy5hcMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Dge761tgQ0mlY7iv1DrK0lD5haulIw6CHqVOuKGMYdUMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexkgEdNxrJJbNUyYhzSll9Nhbh1QfQa8qIgSTsgWbUZdIMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_936O7Uj7orkDLG3CNzj8uecqErEWdjVD7_452B_KWwYWUdUMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index7OSq1iJHOKl_45MfIgNMWjoBhBYxTs0kE4xh_sbvL6CQwMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexEAr7xsjrgX7Cuy3Ki_nQ_45FZE52iNkA7_XzNPGPXyoRsMeta } from "/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGAt5MaoUjUC4InjEy2QgC5TTXeED9kUFEjx6yKCy5hcMeta || {},
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexkgEdNxrJJbNUyYhzSll9Nhbh1QfQa8qIgSTsgWbUZdIMeta || {},
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index7OSq1iJHOKl_45MfIgNMWjoBhBYxTs0kE4xh_sbvL6CQwMeta || {},
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexEAr7xsjrgX7Cuy3Ki_nQ_45FZE52iNkA7_XzNPGPXyoRsMeta || {},
    component: () => import("/codebuild/output/src650457939/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]